export type Reader = {id: string; email: string; name: string};
export type ReaderState = (
  | {state: "guest"; enabled: boolean}
  | {state: "pending"; enabled: true; email: string}
  | {state: "verified"; enabled: true; reader: Reader}) & {previewInbox?: string};
export type ReaderItem = {
  kind: "saved" | "follow";
  id: string;
  title: string;
  href: string;
  createdAt: string;
};
/** The session cookie, shared with heyday.news's subdomains: aws1 answers signed-in reads at api.heyday.news. */
export const READER_COOKIE = "__Secure-hdn_reader";
export const ATTEMPT_COOKIE = "__Host-hdn_reader_attempt";

export function safeReturnPath(value: string | null | undefined): string {
  if (!value || !value.startsWith("/") || value.startsWith("//") || /[\\\x00-\x20]/.test(value)) return "/";
  const url = new URL(value, "https://heyday.news");
  return `${url.pathname}${url.search}`;
}

export const RESEARCH_READER_STORAGE = "heyday:research-reader";
/** Remove this app's persisted drafts and research UI when its reader changes. */
export function clearResearchBrowserState(storage: {length: number; key(index: number): string | null; removeItem(key: string): void}) {
  const keys: string[] = [];
  for (let index = 0; index < storage.length; index++) {
    const key = storage.key(index);
    if (key?.startsWith("heydex:") || key === RESEARCH_READER_STORAGE) keys.push(key);
  }
  for (const key of keys) storage.removeItem(key);
}
